import { Component, OnInit, ViewEncapsulation, Input, Output, ViewChild, ElementRef } from '@angular/core';

import { Terminal } from 'xterm';

import { UserService } from '../../user/user.service';

@Component({
  selector: 'app-serial-terminal',
  templateUrl: './serial-terminal.component.html',
  styleUrls: ['../../../../node_modules/xterm/css/xterm.css'],
  encapsulation: ViewEncapsulation.None
})
export class SerialTerminalComponent implements OnInit {
  private socket: WebSocket;
  private term: Terminal;
  private pid: string;
  private logBuffer: string = '';

  @Input('currSerial') currSerial: any;

  @ViewChild('xtermContainer') xtermContainer: ElementRef;

  constructor( private userService: UserService ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.term = new Terminal();
    console.log(this.xtermContainer, this);
    let containerEl = this.xtermContainer.nativeElement as HTMLElement;

    this.term.open(containerEl);

    this.socket = new WebSocket('wss://remote.controlbright.com:8880', [ this.userService.getToken() ])

    this.socket.addEventListener('open', (event) => {
      this.setupSocket()
    })
  }

  ngOnDestroy() {
    this.socket.close();
  }

  setupSocket() {

    this.prompt()

    this.socket.onmessage = (event) => {
      try {
        let data = JSON.parse(event.data)

        if (data.pid) {
          this.pid = data.pid;
          this.socket.send(JSON.stringify({
            serialConfig: this.currSerial,
            pid: data.pid
          }))
        } else {
          this.write(data.msg);
        }
      } catch (e) {
        console.log(e)
      }
    }

    let buffer = '';

    this.term.onKey(e => {
      const ev = e.domEvent;
      buffer += e.key
      if (ev.keyCode === 13) {
        this.socket.send(JSON.stringify({msg: buffer}))
        buffer = '';
        this.write("\n")
      } else if (ev.keyCode === 8) {
        //if (this.term._core.buffer.x > 2) {
          this.write('\b \b')
        //}
      }
      this.write(e.key)
    })

    this.term.focus()
  }

  prompt() {
    this.write('\r\n')
  }

  write(str: string) {
    this.term.write(str)
    this.logBuffer += str
  }

  downloadLog() {
    let element = document.createElement('a')
    let filename = this.pid+'.txt'

    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.logBuffer));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

}

